import { useState} from "react";

import isEmpty from "lodash/isEmpty";
import map  from "lodash/map";
import get  from "lodash/get";

import Image from "grandus-lib/components-atomic/image/Image";

import styles from "components/product/detail/packageProducts/PackageProducts.module.scss";
import PackageProductDetail from "components/product/detail/packageProducts/PackageProductDetail";

const PackageProducts = ({ packageProducts }) => {

  if(isEmpty(packageProducts)){
      return null;
  }

  const [activeTab, setActiveTab] = useState(
    get(packageProducts, "0.id", false)
  );

  return (
    <div className={styles.packages}>
        <div className="tabs-section">
            <div className="heading text-center hidden-sm-down">
                {map(packageProducts, (pack, index) => {
                    return (
                        <span
                            key={`product-package-label-${pack?.id}-${index}`}
                            className={`tab ${activeTab == pack?.id ? `active` : null}`}
                            onClick={(e) => { setActiveTab(pack?.id); } }
                        >
                            {pack.product.name}
                        </span>
                    );
                })}
            </div>
            <div className="content" >
                {map(packageProducts, (pack, index) => {
                    return (
                        <div key={`product-package-content-${pack?.id}-${index}`}>
                            <div
                                className="tab-heading hidden-sm-up"
                                onClick={(e) => setActiveTab(activeTab == pack?.id ? false : pack?.id)}
                            >
                                {pack.product.name}<i className="fas fa-caret-down"></i>
                            </div>
                            <div 
                                className={`tab ${activeTab == pack?.id ? `show` : null}`}
                            >
                                <h2>{pack?.product?.name}</h2>
                                <div className={styles.parameters}>
                                    <span>Kód výrobcu: {pack?.product?.partNo}</span>
                                    <span>EAN:{pack?.product?.ean}</span>
                                    <span>Grandus ID: {pack?.product?.id}</span>
                                </div>
                                {get(pack, "product.productDescription.description") ? (
                                    <>
                                        <hr/>
                                        <div
                                            className="text"
                                            dangerouslySetInnerHTML={{
                                                __html: get(pack, "product.productDescription.description"),
                                            }}
                                        />
                                    </>
                                ) : (
                                    ""
                                )} 
                                <PackageProductDetail productPackage={pack} />
                            </div>
                        </div>
                    );
                })}
            </div>  
        </div>
    </div>          
  );
};

export default PackageProducts;
